import { Sidebar } from "@similarweb/ui-components";
import { Component } from "react";
import { DashboardWebsitesEditor } from "./dashboardWebsitesEditor";
export class DashboardWebsiteSidebar extends Component<
    {
        //Props
        websites: Array<any>;
        onClickFunc: (websiteMap: FixmeType) => void;
        onSideBarToggle?: () => void;
        onSideBarClose: () => void;
        isOpen: boolean;
    },
    {
        //State
    }
> {
    public render() {
        return (
            <Sidebar
                isSidebarOpen={this.props.isOpen}
                animationDirection={"right"}
                onSidebarToggle={this.props.onSideBarToggle}
                onCloseButtonClick={this.props.onSideBarClose}
                showCloseButton={true}
            >
                <DashboardWebsitesEditor
                    websites={this.props.websites}
                    onClickFunc={this.props.onClickFunc}
                />
            </Sidebar>
        );
    }
}
